<template>
  <div>
<el-dialog
    title="客户详情"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="onHandleClose"
    width="60%"
    center
  >
    <div class="contents CustomerDetailsDialog">
      <el-descriptions :column="3" border>
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="客户姓名"
          >{{ info.fullname }}</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="客户电话"
          >{{ info.mobile }}</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="店铺名称"
          >{{ info.shopname }}</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="从事行业"
          >{{ info.industry_txt }}</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="下单总件数"
          >{{ info.order_qty }}件</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="下单总重量"
          >{{ info.order_gross_weight }}吨</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="注册时间"
          >{{ info.create_time }}</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="注册天数"
          >{{ info.days }}天</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="日均下单件数"
          >{{ info.average_order_day_qty }}件</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="首次下单时间"
          >{{ info.first_order_time }}</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="最近下单时间"
          >{{ info.last_order_time }}</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="平均下单件数"
          >{{ info.average_order_qty }}件</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="缺货件数"
          >{{ info.stockout_num }}件</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="售后件数"
          >{{ info.after_num }}件</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="退款金额"
          >{{ info.refund_amt }}元</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="总退货件数"
          >{{ info.stockout_num + info.after_num }}件</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="客户下单状态"
          >{{ info.customer_status_txt }}</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="客户近 10 日购买二级品top1"
          >{{ info.recent_10days_product_category2_top1 }}</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="客户购买品类偏好"
          >{{ info.customer_buy_category_preference }}</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="客户购买等级偏好"
          >{{ info.customer_buy_grade_preference }}</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="客户近 10 日购买二级品数"
          >{{ info.recent_10days_product_category2_cnt }}</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="客户购买能力"
          >{{ info.purchase_hierarchy }}</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="客户活跃度"
          >{{ info.customer_activity_txt }}</el-descriptions-item
        >
         <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="客户近10日购买水果二级品列表"
          >{{ info.recent_10days_fruit_category2s }}</el-descriptions-item
        > 
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="客户等级"
          >{{ info.star_customer_grade_detail }}</el-descriptions-item
        >
        <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="客户标签"
        >
          <el-tag
            v-for="(item, index) in info.labels"
            :key="index"
            size="small"
            >{{ item.name }}</el-tag
          >
        </el-descriptions-item>
         <el-descriptions-item
          label-class-name="my-label"
          content-class-name="my-content"
          label="客户近10日购买蔬菜二级品类列表"
          >{{ info.recent_10days_vegetable_category2s }}</el-descriptions-item
        > 
          <el-descriptions-item
            label-class-name="my-label"
            content-class-name="my-content"
            label="客户状态"
            >{{ info.black_status_txt }}</el-descriptions-item
          >
          <el-descriptions-item
            v-if="info.black_status == 2&&info.delete_info"
            label-class-name="my-label"
            content-class-name="my-content"
            label="注销时间"
            >{{ info.delete_info.delete_time }}</el-descriptions-item
          >
          <el-descriptions-item
            v-if="info.black_status == 2&&info.delete_info"
            label-class-name="my-label"
            content-class-name="my-content"
            label="注销操作人"
            >{{ info.delete_info.op_name }}</el-descriptions-item
          >
          <el-descriptions-item
            v-if="info.black_status == 2&&info.delete_info"
            label-class-name="my-label"
            content-class-name="my-content"
            label="注销原因"
            >{{ info.delete_info.reason }}

            <el-button type="primary" @click="centerDialogVisible = true" v-if="info.delete_info.pic"
              >查看注销证明</el-button
            >
            <!-- <el-image 
    style="width: 100px; height: 100px"
    :src="info.delete_inf.pic.split(',')[0]" 
    :preview-src-list="info.delete_inf.pic.split(',')">
  </el-image> -->
          </el-descriptions-item>
      </el-descriptions>
      
    </div>
    <span slot="footer">
      <el-button @click="onHandleClose">取 消</el-button>
    </span>
  </el-dialog>
      <el-dialog
      title="提示"
      v-if="centerDialogVisible"
      :visible.sync="centerDialogVisible"
      width="60%"
      center
    >
    <div style="height: 500px;overflow-y: auto;">
      <el-image
        v-for="url in info.delete_info.pic.split(',')"
        :key="url"
        :src="url"
        lazy
      ></el-image>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
  
</template>

<script>
import { postMemberInfo } from "@/api/system/index";
export default {
  name: "CustomerDetailsDialog",
  data() {
    return {
      centerDialogVisible:false,
      dialogVisible: false,
      submitLoading: false,
      info: "",
    };
  },
  methods: {
    /**
     * 初始化
     */
    async onInitData(id) {
      try {
        const { data } = await postMemberInfo({ member_id: id });
        this.info = data;
        this.dialogVisible = true;
      } catch (err) {
        console.log("ajax postMemberInfo err", err);
      }
    },
    /**
     * 关闭操作
     */
    onHandleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style  lang="scss">
.CustomerDetailsDialog {
  .my-label {
    // background: #f9f9f9;
    color: #000;
    font-weight: 700;
  }

  .my-content {
    // background: #fde2e2;
     color: #000;
  }
}
</style>
